import {Container, Label, ProgressText} from './style-component';
import {MissionStepProps} from './mission-step-types'

const MissionStep: React.FC<MissionStepProps> = ({ label, totalCompleted, totalMissions }) => {

  return (
    <Container>
      <Label>{label}</Label>
      <ProgressText>{`${totalCompleted} / ${totalMissions}`}</ProgressText>
    </Container>
  );
};

export default MissionStep;
